import React from 'react';
import { View } from 'react-native';
import { Checkbox } from '@material-ui/core';
import CustomFormInput from './CustomFormInput';
import _ from 'root/libs/exaforte/react/lodash';

export default class CustomCheckBox extends CustomFormInput {
    _onChange(event) {
        if(this.props.onChangeText)
            this.props.onChangeText(event.target.checked ? 't' : 'f');
    }
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {icon: true, checkedIcon: true})};
    }

    getElement() {
        let props       = this.getSupportedProps();
        props.checked   = (props.value == 't');

        return <Checkbox autoComplete="off" onChange={this._onChange} {...props} />;
    }
}